// CSS
import './styles/global.scss';
// Imported for loading in the icons
// eslint-disable-next-line no-unused-vars
import requireIcons from './styles/icons';
// For pollyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import _browserScrollbarFix from './modules/_global/js/browserScrollbarFix';

_browserScrollbarFix();
